// extracted by mini-css-extract-plugin
export var active = "GlobalSearch-module--active--b2c9d";
export var alt = "GlobalSearch-module--alt--91657";
export var dates = "GlobalSearch-module--dates--42e5f";
export var desktopOnly = "GlobalSearch-module--desktopOnly--2547c";
export var dropdownText = "GlobalSearch-module--dropdownText--cdc4b";
export var editIcon = "GlobalSearch-module--edit-icon--73ec5";
export var form = "GlobalSearch-module--form--a7a99";
export var isOfferModal = "GlobalSearch-module--is-Offer-Modal--a4c99";
export var location = "GlobalSearch-module--location--5990f";
export var main = "GlobalSearch-module--main--98a41";
export var mapIcon = "GlobalSearch-module--map-icon--a8e28";
export var memberDiscountList = "GlobalSearch-module--memberDiscountList--54c23";
export var mobileOnly = "GlobalSearch-module--mobileOnly--e63ee";
export var mobileStickyHeader = "GlobalSearch-module--mobile-sticky-header--cde19";
export var occupancyText = "GlobalSearch-module--occupancyText--14739";
export var reactAutosuggest__container = "GlobalSearch-module--react-autosuggest__container--77fc5";
export var searchForm = "GlobalSearch-module--searchForm--beee7";
export var searchFormHotelSearchModal = "GlobalSearch-module--searchFormHotelSearchModal--6d7ba";
export var textLeft = "GlobalSearch-module--textLeft--9af88";
export var visuallyHidden = "GlobalSearch-module--visuallyHidden--0c49f";